import _defineProperty from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
// ../../../react-shim.js
import React from "react"; // src/color-mode-provider.tsx

import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { useCallback, useEffect, useMemo, useState } from "react"; // src/color-mode-context.ts

import { createContext, useContext } from "react";
var ColorModeContext = createContext({});
ColorModeContext.displayName = "ColorModeContext";

function useColorMode() {
  var context = useContext(ColorModeContext);

  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }

  return context;
}

function useColorModeValue(light, dark) {
  var _useColorMode = useColorMode(),
      colorMode = _useColorMode.colorMode;

  return colorMode === "dark" ? dark : light;
} // src/color-mode.utils.ts


var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};

function getColorModeUtils() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$preventTrans = options.preventTransition,
      preventTransition = _options$preventTrans === void 0 ? true : _options$preventTrans;
  var utils = {
    setDataset: function setDataset(value) {
      var cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName: function setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query: function query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme: function getSystemTheme(fallback) {
      var _utils$query$matches;

      var dark = (_utils$query$matches = utils.query().matches) !== null && _utils$query$matches !== void 0 ? _utils$query$matches : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener: function addListener(fn) {
      var mql = utils.query();

      var listener = function listener(e) {
        fn(e.matches ? "dark" : "light");
      };

      if (typeof mql.addListener === "function") mql.addListener(listener);else mql.addEventListener("change", listener);
      return function () {
        if (typeof mql.removeListener === "function") mql.removeListener(listener);else mql.removeEventListener("change", listener);
      };
    },
    preventTransition: function preventTransition() {
      var css = document.createElement("style");
      css.appendChild(document.createTextNode("*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"));
      document.head.appendChild(css);
      return function () {
        ;

        (function () {
          return window.getComputedStyle(document.body);
        })();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
} // src/storage-manager.ts


var STORAGE_KEY = "chakra-ui-color-mode";

function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get: function get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document)) return init;
      var value;

      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {}

      return value || init;
    },
    set: function set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    }
  };
}

var localStorageManager = createLocalStorageManager(STORAGE_KEY);

function parseCookie(cookie, key) {
  var match = cookie.match(new RegExp("(^| )".concat(key, "=([^;]+)")));
  return match == null ? void 0 : match[2];
}

function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get: function get(init) {
      if (cookie) return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document)) return init;
      return parseCookie(document.cookie, key) || init;
    },
    set: function set(value) {
      document.cookie = "".concat(key, "=").concat(value, "; max-age=31536000; path=/");
    }
  };
}

var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);

var cookieStorageManagerSSR = function cookieStorageManagerSSR(cookie) {
  return createCookieStorageManager(STORAGE_KEY, cookie);
}; // src/color-mode-provider.tsx


var noop = function noop() {};

function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}

function ColorModeProvider(props) {
  var value = props.value,
      children = props.children,
      _props$options = props.options;
  _props$options = _props$options === void 0 ? {} : _props$options;
  var useSystemColorMode = _props$options.useSystemColorMode,
      initialColorMode = _props$options.initialColorMode,
      disableTransitionOnChange = _props$options.disableTransitionOnChange,
      _props$colorModeManag = props.colorModeManager,
      colorModeManager = _props$colorModeManag === void 0 ? localStorageManager : _props$colorModeManag;
  var defaultColorMode = initialColorMode === "dark" ? "dark" : "light";

  var _useState = useState(function () {
    return getTheme(colorModeManager, defaultColorMode);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      colorMode = _useState2[0],
      rawSetColorMode = _useState2[1];

  var _useState3 = useState(function () {
    return getTheme(colorModeManager);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      resolvedColorMode = _useState4[0],
      setResolvedColorMode = _useState4[1];

  var _useMemo = useMemo(function () {
    return getColorModeUtils({
      preventTransition: disableTransitionOnChange
    });
  }, [disableTransitionOnChange]),
      getSystemTheme = _useMemo.getSystemTheme,
      setClassName = _useMemo.setClassName,
      setDataset = _useMemo.setDataset,
      addListener = _useMemo.addListener;

  var resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  var setColorMode = useCallback(function (value2) {
    var resolved = value2 === "system" ? getSystemTheme() : value2;
    rawSetColorMode(resolved);
    setClassName(resolved === "dark");
    setDataset(resolved);
    colorModeManager.set(resolved);
  }, [colorModeManager, getSystemTheme, setClassName, setDataset]);
  useSafeLayoutEffect(function () {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  useEffect(function () {
    var managerValue = colorModeManager.get();

    if (managerValue) {
      setColorMode(managerValue);
      return;
    }

    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }

    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  var toggleColorMode = useCallback(function () {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  useEffect(function () {
    if (!useSystemColorMode) return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  var context = useMemo(function () {
    return {
      colorMode: value !== null && value !== void 0 ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    };
  }, [resolvedValue, toggleColorMode, setColorMode, value]);
  return /* @__PURE__ */React.createElement(ColorModeContext.Provider, {
    value: context
  }, children);
}

ColorModeProvider.displayName = "ColorModeProvider";

function DarkMode(props) {
  var context = useMemo(function () {
    return {
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    };
  }, []);
  return /* @__PURE__ */React.createElement(ColorModeContext.Provider, _objectSpread({
    value: context
  }, props));
}

DarkMode.displayName = "DarkMode";

function LightMode(props) {
  var context = useMemo(function () {
    return {
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    };
  }, []);
  return /* @__PURE__ */React.createElement(ColorModeContext.Provider, _objectSpread({
    value: context
  }, props));
}

LightMode.displayName = "LightMode"; // src/color-mode-script.tsx

var VALID_VALUES = /* @__PURE__ */new Set(["dark", "light", "system"]);

function normalize(initialColorMode) {
  var value = initialColorMode;
  if (!VALID_VALUES.has(value)) value = "light";
  return value;
}

function getScriptSrc() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$initialColorMo = props.initialColorMode,
      initialColorMode = _props$initialColorMo === void 0 ? "light" : _props$initialColorMo,
      _props$type = props.type,
      type = _props$type === void 0 ? "localStorage" : _props$type,
      _props$storageKey = props.storageKey,
      key = _props$storageKey === void 0 ? "chakra-ui-color-mode" : _props$storageKey;
  var init = normalize(initialColorMode);
  var isCookie = type === "cookie";
  var cookieScript = "(function(){try{var a=function(o){var l=\"(prefers-color-scheme: dark)\",v=window.matchMedia(l).matches?\"dark\":\"light\",e=o===\"system\"?v:o,d=document.documentElement,m=document.body,i=\"chakra-ui-light\",n=\"chakra-ui-dark\",s=e===\"dark\";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h=\"".concat(init, "\",r=\"").concat(key, "\",t=document.cookie.match(new RegExp(\"(^| )\".concat(r,\"=([^;]+)\"))),c=t?t[2]:null;c?a(c):document.cookie=\"\".concat(r,\"=\").concat(a(h),\"; max-age=31536000; path=/\")}catch(a){}})();\n  ");
  var localStorageScript = "(function(){try{var a=function(c){var v=\"(prefers-color-scheme: dark)\",h=window.matchMedia(v).matches?\"dark\":\"light\",r=c===\"system\"?h:c,o=document.documentElement,s=document.body,l=\"chakra-ui-light\",d=\"chakra-ui-dark\",i=r===\"dark\";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m=\"".concat(init, "\",e=\"").concat(key, "\",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();\n  ");
  var fn = isCookie ? cookieScript : localStorageScript;
  return "!".concat(fn).trim();
}

function ColorModeScript() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nonce = props.nonce;
  return /* @__PURE__ */React.createElement("script", {
    id: "chakra-script",
    nonce: nonce,
    dangerouslySetInnerHTML: {
      __html: getScriptSrc(props)
    }
  });
}

export { ColorModeContext, ColorModeProvider, ColorModeScript, DarkMode, LightMode, cookieStorageManager, cookieStorageManagerSSR, createCookieStorageManager, createLocalStorageManager, getScriptSrc, localStorageManager, useColorMode, useColorModeValue };